import { render } from "./AdminComptabiliteMicro.vue?vue&type=template&id=0332532d&scoped=true"
import script from "./AdminComptabiliteMicro.vue?vue&type=script&lang=js"
export * from "./AdminComptabiliteMicro.vue?vue&type=script&lang=js"

import "./AdminComptabiliteMicro.vue?vue&type=style&index=0&id=0332532d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0332532d"]])

export default __exports__